module.exports = __webpack_public_path__ + "img/zip-icon.72ea770c.svg";